<div *ngIf="isActive"  class="vertical-center">
  <div class="res-container">
    <p>
      JanguKit Code Repository
    </p>
    <button class="access-btn" (click)="goToRepository()">
    <img src="./assets/github.svg" height="40px" alt="Google Logo" class="google-logo">
      Access to JanguKit Code base repository
    </button>
  </div>
</div>
